export const APP_URL = window.location.hostname.indexOf('localhost') > -1 ? 'http://localhost:3000' : 'https://fm.ghien.cafe';